export { default as UmOkkurBanner } from './um-okkur-banner';



// WEBPACK FOOTER //
// ./src/components/about-us/um-okkur-banner/index.ts